import { render, staticRenderFns } from "./PhotoGalleryTable.vue?vue&type=template&id=85f47a48&scoped=true"
import script from "./PhotoGalleryTable.vue?vue&type=script&lang=js"
export * from "./PhotoGalleryTable.vue?vue&type=script&lang=js"
import style0 from "./PhotoGalleryTable.vue?vue&type=style&index=0&id=85f47a48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f47a48",
  null
  
)

export default component.exports